var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_747_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57959 28.4007C4.21713 27.601 5.40721 27.4747 6.18927 28.1397C7.77888 29.4865 10.6011 31.3889 13.7888 31.3889C15.7524 31.3889 17.7246 30.6818 17.7246 28.5185C17.7246 24.2508 0.0178429 23.7626 0.0178429 11.6414C0.0178429 4.65488 6.18927 0 13.9503 0C19.1442 0 26.4122 2.49158 26.4122 8.39226V10.9343C26.4122 11.8603 25.6556 12.6094 24.7205 12.6094H19.3652C18.4301 12.6094 17.6736 11.8603 17.6736 10.9343C17.6736 9.52862 15.6504 8.66162 13.8483 8.66162C11.8847 8.66162 9.86152 9.4697 9.86152 11.2626C9.86152 15.968 27.5682 15.3199 27.5682 28.0387C27.5682 34.4781 22.4849 40 13.6868 40C7.06483 40 2.57652 36.6751 0.587382 34.8232C-0.101165 34.1751 -0.186171 33.1145 0.40887 32.3822L3.59659 28.4007H3.57959Z",
    fill: "#00A281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0907 19.1582V38.5943C63.0907 39.2172 62.5807 39.7222 61.9516 39.7222H54.7771C54.1481 39.7222 53.638 39.2172 53.638 38.5943V19.1582H51.1559C50.6203 19.1582 50.1953 18.729 50.1953 18.2071V12.803C50.1953 12.2727 50.6288 11.8518 51.1559 11.8518H53.638V11.2037C53.638 2.05387 62.0026 0.808075 66.5419 0.808075C67.409 0.808075 68.1315 0.850162 68.6331 0.89225C69.0581 0.92592 69.3896 1.27946 69.3896 1.70875V7.97138C69.3896 8.44276 68.9901 8.81313 68.5141 8.78787C68.3186 8.77946 68.0975 8.77104 67.851 8.77104C65.9894 8.77104 63.0992 9.09932 63.0992 11.4815V11.8603",
    fill: "#00A281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4294 28.1987C84.4294 31.3384 87.6511 31.7677 89.4618 31.7677H89.4873C90.1673 31.7677 90.7199 32.3148 90.7199 32.9798V38.729C90.7199 39.3687 90.2183 39.899 89.5808 39.9411C89.1813 39.9663 88.6967 39.9916 88.1527 39.9916C83.6729 39.9916 74.9768 38.8047 74.9768 29.436L74.9258 2.23905C74.9258 1.56565 75.4783 1.02693 76.1499 1.02693H83.1968C83.8769 1.02693 84.4209 1.57407 84.4209 2.23905V28.1902L84.4294 28.1987Z",
    fill: "#00A281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3759 1.37206C28.8691 1.37206 20.3516 9.8064 20.3516 20.2104C20.3516 30.6145 28.8691 39.0488 39.3759 39.0488C49.8826 39.0488 58.4002 30.6145 58.4002 20.2104C58.4002 9.8064 49.8826 1.37206 39.3759 1.37206ZM39.3759 29.5118C34.1905 29.5118 29.9827 25.3451 29.9827 20.2104C29.9827 15.0758 34.1905 10.9091 39.3759 10.9091C44.5612 10.9091 48.769 15.0758 48.769 20.2104C48.769 25.3451 44.5612 29.5118 39.3759 29.5118Z",
    fill: "#00A281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6309 32.6936C56.5976 29.3687 58.3997 25 58.3997 20.2188C58.3997 15.4377 56.7421 11.4225 53.9879 8.15656C53.7499 9.05723 53.6224 10.0757 53.6224 11.2121V11.8603H51.1403C50.6047 11.8603 50.1797 12.2896 50.1797 12.8114V18.2155C50.1797 18.7458 50.6132 19.1667 51.1403 19.1667H53.6224V32.6936H53.6309Z",
    fill: "url(#paint0_linear_747_370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5386 17.4326C20.4111 18.2997 20.3516 19.1919 20.3516 20.0926C20.3516 25.3788 22.5532 30.1599 26.098 33.5858C27.0585 31.8855 27.5686 29.9495 27.5686 27.9209C27.5686 22.4411 24.2873 19.4444 20.5471 17.4326H20.5386Z",
    fill: "url(#paint1_linear_747_370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7197 12.4916C25.6548 12.4916 26.4113 11.7424 26.4113 10.8165V8.2744C26.4113 7.65151 26.3263 7.0707 26.1733 6.52356C24.4052 8.21548 22.9601 10.2357 21.957 12.4916H24.7112H24.7197Z",
    fill: "url(#paint2_linear_747_370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5312 11.8939H89.8011C90.3367 11.8939 90.7617 12.3232 90.7617 12.8451V18.2492C90.7617 18.7795 90.3282 19.2003 89.8011 19.2003H62.5312V11.8939Z",
    fill: "url(#paint3_linear_747_370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_747_370",
    x1: 72.0432,
    y1: -0.126276,
    x2: 48.3033,
    y2: 27.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#006C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_747_370",
    x1: 35.3806,
    y1: 9.234,
    x2: 19.1917,
    y2: 31.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#006C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_747_370",
    x1: 18.8713,
    y1: 2.54208,
    x2: 28.4141,
    y2: 15.5778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#006C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_747_370",
    x1: 62.5312,
    y1: 15.5471,
    x2: 90.7702,
    y2: 15.5471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#006C56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_747_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.7692,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41ec7889e923c13bedbc1cb06338efcb.svg";
export { ForwardRef as ReactComponent };